import React from 'react';
import type { SafeAreaViewProps } from 'react-native-safe-area-context';
import { SafeAreaView as SafeAreaViewContext } from 'react-native-safe-area-context';

import { styles } from './styles';

export function SafeAreaView({ ...props }: SafeAreaViewProps) {
  return <SafeAreaViewContext {...props} style={[styles.container]} />;
}
